import { Modal } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { PropsWithChildren } from 'react';

import { BottomSheet } from './bottom-sheet';

type ResponsiveModalProps = PropsWithChildren<{
  opened: boolean;
  onClose: () => void;
  onExitTransitionEnd?: () => void;
  title: string;
  closeLabel?: string;
  contentSized?: boolean;
  trapFocus?: boolean;
  closeOnEscape?: boolean;
  zIndex?: number;
}>;

export const ResponsiveModal = ({
  opened,
  onClose,
  onExitTransitionEnd,
  title,
  closeLabel,
  contentSized,
  trapFocus = true,
  closeOnEscape = true,
  zIndex,
  children,
}: ResponsiveModalProps) => {
  const isMobile = useMediaQuery('(max-width: 35.99em)', false, { getInitialValueInEffect: false });
  const accessibleCloseLabel = closeLabel ?? `Закрыть: ${title.toLowerCase()}`;

  if (isMobile) {
    return (
      <BottomSheet
        opened={opened}
        onClose={onClose}
        onExitTransitionEnd={onExitTransitionEnd}
        title={title}
        closeLabel={accessibleCloseLabel}
        contentSized={contentSized}
        trapFocus={trapFocus}
        closeOnEscape={closeOnEscape}
        zIndex={zIndex}
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      onExitTransitionEnd={onExitTransitionEnd}
      title={title}
      trapFocus={trapFocus}
      closeOnEscape={closeOnEscape}
      zIndex={zIndex}
      centered
      size="31rem"
      padding={0}
      radius="xl"
      closeButtonProps={{ 'aria-label': accessibleCloseLabel }}
    >
      {children}
    </Modal>
  );
};
